import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Errors from './components/Errors';
import Dashboard from './components/Dashboard';
import { ThemeProvider, defaultTheme } from '@nike/ruxac';

function App() {
  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="container">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="*" element={<Errors />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
